import { Country } from '../enums';

export const Countries = [
  Country.AUSTRIA,
  Country.BELGIUM,
  Country.ENGLAND,
  Country.FRANCE,
  Country.GERMANY,
  Country.IRELAND,
  Country.ITALY,
  Country.SPAIN,
  Country.SWITZERLAND,
  Country.USA,
];
